<h1 class="table__title" >Assign New Legal Counsel</h1>
  
<div class="form-container">
    <mat-form-field appearance="outline" required *ngIf="null | asyncLegalCounselAll | async as legalCounselAll"
        matTooltip="The name of the legal counsel that is responsible for the document">
        <mat-label>User Name</mat-label>
        <mat-select #ContractLegalCounsel="ngModel" name="ContractLegalCounsel"
        [(ngModel)]="data.ContractLegalCounsel" required (selectionChange)="onLegalCounselChange($event)">
        <ngx-mat-select-search name="lcSearch" [(ngModel)]="lcSearch" [placeholderLabel]="'Search...'"
            [noEntriesFoundLabel]="'notfound'"></ngx-mat-select-search>
        <mat-option value="" disabled selected>Please select</mat-option>
        <mat-option *ngFor="let legalCounsel of legalCounselAll | stringFilterBy : lcSearch : 'fullname'" [value]="legalCounsel.id">
            {{legalCounsel.fullname}}
        </mat-option>
        </mat-select>
        <mat-error *ngIf="ContractLegalCounsel?.errors?.required">
        Field is required
        </mat-error>
    </mat-form-field>
</div>

<ul class="table__control inline-list">
  <li>
    <div>
    <button mat-raised-button color="accent" (click)="onCloseClick()" >Close</button>
    </div>
  </li>
  <li >
    <button mat-raised-button [disabled]="!data.ContractLegalCounsel" color="primary" (click)="onAssignClick()" >Assign</button>
  </li>
</ul>
<div *ngIf="loading$ | async" class="spinner">
  <mat-spinner></mat-spinner>
</div>



